module.exports = __webpack_public_path__ + "static/how-it-works-1-b193a3d99d083f3ffd32dc1e04da1874.png";